module.exports = __webpack_public_path__ + "img/logo-login.500ef178.png";